<div class="container tooltip fade mx-auto w-80 h-auto">
  <div class="py-2 flex justify-between border-b items-center">
    <p class="text-sm tooltip-title title-font uppercase ml-2">{{'assign.employee.title' | translate}}</p>
    <button
      mat-icon-button
      class="tooltip-close cursor-pointer items-center mr-2 h-8 w-8" (click)="closeTooltip()">
      <i class="ti ti-x text-xl"></i>
    </button>
  </div>      
  <div class="tooltip-main container rounded w-auto h-full" [ngClass]="{'mt-2': (!isMultiSelect || (isMultiSelect && assignListData?.length > 1))}">
    <div *ngIf="!addNew" [formGroup]="assignEmployeeForm">
      <div class="max-h-60 overflow-y-auto zuper-scrollbar">
        <ng-container *ngFor="let u of assignListData">
          <div class="tooltip-list px-4 py-2" *ngIf="u?.value === 'unassign' && !isMultiSelect">
            <div class="flex items-center">
              <input id="unassign" type="radio" value="unassign" formControlName="assign"
                class="h-4 w-4 border-gray-300 text-indigo-600">
              <label for="unassign" class="ml-3 block text-base font-medium text-gray-700 cursor-pointer">
                <div class="tooltip-content pl-2">
                  <p class="my-0 ml-2 text-base">{{this.assignedEmployee?.user?.user_uid ? ('text.unassign' | translate) :
                    ('unassigned.text' | translate)}}</p>
                </div>
              </label>
            </div>
          </div>
          <div class="tooltip-list px-4 py-2" *ngIf="u?.value !== 'unassign'">
            <div class="flex items-center">
              <input id="{{u?.user?.user_uid+'_'+u?.team?.team_uid}}" *ngIf="!isMultiSelect" type="radio"
                value="{{u?.user?.user_uid+'_'+u?.team?.team_uid}}" formControlName="assign"
                class="h-4 w-4 border-gray-300 text-indigo-600">
              <input id="{{u?.user?.user_uid+'_'+u?.team?.team_uid}}" *ngIf="isMultiSelect" type="checkbox"
                value="{{u?.user?.user_uid+'_'+u?.team?.team_uid}}" (change)="updateEmployeeAssign($event, u)"
                [checked]="isSelectedEmployee(u)" class="h-4 w-4 border-gray-300 text-indigo-600">
              <label for="{{u?.user?.user_uid+'_'+u?.team?.team_uid}}"
                class="ml-3 block text-base font-medium text-gray-700 cursor-pointer flex">
                <div *ngIf="!u?.user?.profile_picture || !utilityService.hasValidProfilePicture(u?.user?.profile_picture)"
                  class="flex flex-0 items-center justify-center w-10 h-10 overflow-hidden">
                  <div
                    class="flex items-center justify-center w-full h-full rounded-md text-lg uppercase bg-gray-200 text-gray-600 dark:bg-gray-700 dark:text-gray-200 ng-star-inserted">
                    {{u?.user?.first_name.slice(0,1)}} </div>
                </div>
                <div class="flex-shrink-0 h-10 w-10" *ngIf="utilityService.hasValidProfilePicture(u?.user?.profile_picture)">
                  <img class="h-10 w-10 rounded-md" src="{{u?.user?.profile_picture}}" alt="">
                </div>
                <div class="tooltip-content pl-2 flex flex-col items-start">
                  <p class="text-base">{{u?.user?.first_name}} {{u?.user?.last_name}}</p>
                  <small class="text-secondary my-2" *ngIf="u?.team?.team_name">{{u?.team?.team_name}}</small>
                </div>
              </label>
            </div>
          </div>
        </ng-container>
      </div>
      <div class="border-b px-4 py-2 border-gray-200 flex justify-center items-center cursor-pointer" (click)="addNew=true" [ngClass]="{'border-t': (!isMultiSelect || (isMultiSelect && assignListData?.length > 1))}">
        <span class="text-base text-blue-500"><em class="ti ti-plus"></em>{{'add.text' | translate}} {{'new' | translate}}</span>
      </div>
      <div class="border-b px-4 py-2 border-gray-200 flex justify-start items-center cursor-pointer" *ngIf="!utilityService.isEmptyOrUndefined(assignEmployeeForm?.value?.assign) && assignEmployeeForm?.value?.assign !== 'unassign' && this.showNotifyEmployee">
        <div class="relative flex items-start mt-2">
          <div class="flex h-5 items-center">
            <input id="notifyUser" name="notifyUser" type="checkbox" formControlName="notify_users" [checked]="assignEmployeeForm?.value?.notify_users" class="h-4 w-4 rounded-lg border-gray-300 text-indigo-600">
          </div>
          <div class="ml-3 text-base">
            <label for="notifyUser" class="font-medium text-gray-700 cursor-pointer" >{{'newtimeoff.notify.user.label' | translate}}</label>
          </div>
        </div>
      </div>
      <div class="px-4 py-2 w-full">
        <button (click)="emitAssignedEmployee()"
            class="bg-primary w-full btn-small px-6 items-center py-2 border b-1 shadow-sm text-white text-base font-medium rounded-md text-white-600 focus:outline-none">
            {{'text.save' | translate}}
        </button>
      </div>
    </div>
    <div *ngIf="addNew">
      <div class="w-full py-4 px-2 z-10 flex justify-between items-center">
        <div class="rounded-full p-4 h-8 w-8 border flex justify-center items-center" (click)="addNew=false">
          <em class="ti ti-chevron-left"></em>
        </div>
        <div class="w-60">
          <div class="max-w-md w-full">
            <div class="relative flex flex-col">
                <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <em class="ti ti-search cursor-pointer"></em>
                </div>
                <input type="text" id="searchKey" name="searchKey" [(ngModel)]="searchText"
                    (keyup.enter)="getUsers(searchText)" spellcheck="false"
                    class="input-height text-base block w-full pl-10 pr-10 py-2.5 primary-font border Searchborder-gray-300 rounded-md bg-white placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:border-indigo-500"
                    placeholder="{{'users.table.search_place_holder' | translate}}"
                    autocomplete="off">
                <div *ngIf="searchText.length"
                    class="h-9 w-9 mt-1 mr-0.5 cursor-pointer absolute inset-y-0 flex items-center justify-center right-0 rounded-full hover:bg-gray-100"
                    (click)="searchText = ''; getUsers(searchText)">
                    <em class="ti ti-x cursor-pointer"></em>
                </div>
            </div>
          </div>
        </div>
      </div>
      <div class="max-h-60 overflow-y-auto zuper-scrollbar">
        <div class="tooltip-list px-4 py-2" *ngFor="let u of searchData">
          <div class="flex items-center">
            <input id="{{u?.user?.user_uid+'_'+u?.team?.team_uid}}" *ngIf="isMultiSelect" type="checkbox"
              value="{{u?.user?.user_uid+'_'+u?.team?.team_uid}}" (change)="selectEmployees($event, u)"
              [checked]="isSelectedEmployee(u)" class="h-4 w-4 border-gray-300 text-indigo-600 mr-3">
            <label (click)="!isMultiSelect ? selectUser(u) : null" class="flex cursor-pointer" for="{{u?.user?.user_uid+'_'+u?.team?.team_uid}}">
              <div *ngIf="!u?.user?.profile_picture || !utilityService.hasValidProfilePicture(u?.user?.profile_picture)"
                class="flex flex-0 items-center justify-center w-10 h-10 overflow-hidden">
                <div
                  class="flex items-center justify-center w-full h-full rounded-md text-lg uppercase bg-gray-200 text-gray-600 dark:bg-gray-700 dark:text-gray-200 ng-star-inserted">
                  {{u?.user?.first_name.slice(0,1)}} </div>
              </div>
              <div class="flex-shrink-0 h-10 w-10" *ngIf="utilityService.hasValidProfilePicture(u?.user?.profile_picture)">
                <img class="h-10 w-10 rounded-md" src="{{u?.user?.profile_picture}}" alt="">
              </div>
              <div class="tooltip-content pl-2 flex flex-col items-start">
                <p class="text-base">{{u?.user?.first_name}} {{u?.user?.last_name}}</p>
                <small class="text-secondary my-2" *ngIf="u?.team?.team_name">{{u?.team?.team_name}}</small>
              </div>
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>